export default "__VITE_ASSET__BVbrFjdd__"